/**
 * The coordinate frame for everything the engine renders.
 *
 * `engine.sample()` outputs coordinates in viewBox units, and these two numbers
 * define them: without them, engine output is meaningless. They lived in
 * `LosiBot.vue`, therefore out of reach — a `<script setup>` exports nothing —
 * and `export.ts` redeclared one by hand with a comment that named the problem.
 *
 * They are here because `src/bot/` is what gets read and consumed from outside:
 * the Vue component is ONE client of the engine, not its definition.
 */

/**
 * Ball radius at rest, in viewBox units. This is the `scale` the component
 * passes to `BotEngine`.
 *
 * Chosen, not measured: it is the working unit. Everything else in this folder
 * is expressed as fractions of this radius, which makes measurements taken from
 * the video independent of display size.
 */
export const RAYON = 100

/**
 * Half-side of the displayed viewBox. The margin beyond the radius holds the rings.
 *
 * Not a free value: orbit rings and the comet swoosh reach 1.4 times the radius,
 * i.e. 140. Nothing bounds them at runtime — hand-tuning the `RINGS` and `SWOOSH`
 * tables (`decor.ts`) keeps them under 158, and a test locks that in.
 */
export const DEMI_VIEWBOX = 158
